import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Totes.frontend.types'

@Injectable({ providedIn: 'root' })
export class Totes_totinizationService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { waveTasks?: $frontendTypes.Totes.waveTasks[], weightCapacity?: number, dimFactor?: number }): Promise<{ groupedTotes?: { toteGroup: number, waveTasks: $frontendTypes.Totes.waveTasks[] }[] }> 
  {
    let $url = `${environment.backendUrl}api/Totes/functions/totinization`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

